/**
 * 新テンプレート (災害時避難先のご案内) のデザイントークン。
 *
 * Figma ファイル `Fk7Lf27uU0ClDgWBASGs9o` から実測した生 hex 値。
 * (Figma 側はバインド変数を持たないため、ここで一元管理する。)
 *
 * CSS では `src/styles/evacuation-sites.css` の custom properties (--es-*) を使い、
 * JS (矢印の色など描画ロジック) ではこの定数を import して使う。
 * 両者の値は常に一致させること (evacuation-sites-css.test.ts が検証する)。
 */

export const ES_COLOR = {
  /** 避難場所 / EVACUATION AREA / 赤矢印 */
  red: '#c82023',
  /** 避難所 / SHELTER / 橙矢印 */
  orange: '#ef7b06',
  /** 浸水カード枠 / 物件ピン (ネイビー)。nomura デザインのブランド色。 */
  navy: '#10337b',
  /** ヘッダー帯のネイビー (やや濃い)。nomura デザインのブランド色。 */
  headerNavy: '#0a2865',
  /**
   * default デザインのテーマ色の初期値 (ネイビー)。
   *
   * nomura のブランドネイビー (#10337b) とは別の、彩度のあるモダンな濃紺。
   * ヘッダー帯は白文字なので、明るすぎると読めなくなる — この値で 10.4:1
   * (blue-800 #1e40af まで明るくすると 8.7:1、blue-700 #1d4ed8 では 6.7:1
   * まで落ち、避難場所(赤)との差も詰まる)。
   */
  defaultTheme: '#1e3a8a',
  /** 防災ポータル見出しの緑 */
  portalGreen: '#128900',
  /** 本文テキスト (ほぼ黒) */
  ink: '#020304',
  white: '#ffffff',
} as const;

/** 避難先種別 / 物件ごとの矢印・タグ色。 */
export const ARROW_COLOR = {
  evacuationArea: ES_COLOR.red,
  shelter: ES_COLOR.orange,
  building: ES_COLOR.navy,
} as const;

/** 1920×1080 ステージのレイアウト固定値 (Figma 実測)。 */
export const ES_LAYOUT = {
  stageWidth: 1920,
  stageHeight: 1080,
  headerHeight: 133,
  footerHeight: 69,
  bodyHeight: 878, // 1080 - 133 - 69
  cardsWidth: 400,
  mapWidth: 1287,
  qrWidth: 233, // 400 + 1287 + 233 = 1920
} as const;
